// extracted by mini-css-extract-plugin
export default {"component":"chm6_61m","children":"i61k4I3n","logo":"tSPGdHiE"};